import { useEffect } from 'react';

import { debounce } from 'lodash';

const DELAY_DEFAULT_MS = 200;
const SELECTOR_DEFAULT = '#scrollable-target';

interface UseActionOnScrollProps {
  onAction: () => void;
  active?: boolean;
  scrollSelector?: string | null;
  delay?: number;
}

export const useActionOnScroll = ({
  onAction,
  active = true,
  scrollSelector = SELECTOR_DEFAULT,
  delay = DELAY_DEFAULT_MS,
}: UseActionOnScrollProps) => {
  const scrollableContainer =
    (scrollSelector && document.querySelector(scrollSelector)) || window;

  useEffect(() => {
    if (!active) return;

    const debounced = debounce(onAction, delay);

    scrollableContainer.addEventListener('scroll', debounced, {
      passive: true,
    });

    return () => {
      debounced.cancel();
      scrollableContainer.removeEventListener('scroll', debounced);
    };
  }, [onAction, active, delay, scrollableContainer]);
};
